/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PriceCalculationStrategyDto } from "./Order/PriceCalculationStrategyDto";
import { ConfigurationTemplatePriceCalculationActor } from "./ConfigurationTemplatePriceCalculationActor";

export class ConfigurationTemplatePriceCalculationDto {
    id: string | null;
    priceCalculationStrategy: PriceCalculationStrategyDto;
    priceCalculationStrategyId: string | null;
    actor: ConfigurationTemplatePriceCalculationActor;
    configurationTemplateId: string;
}
